import React from 'react'
import PDFIcon from "../../images/pdf-icon.svg";
import CSVIcon from "../../images/csv-icon.svg";
import DeleteIcon from "../../images/delete-icon.svg";

interface IFileItemProps {
  file: any,
  removeFile?: Function;
  handleClick?: Function;
}

const FileItem = (props: IFileItemProps) => {
  const { file, removeFile, handleClick } = props;

  // get icons related to the type of file
  const getFileImage = (file: any) => {
    const path = file?.path;
    if (path?.toLowerCase()?.includes('pdf')) {
      return <img src={PDFIcon} alt="PDFIcon" className="file-icon" />
    } else if (path?.toLowerCase()?.includes('csv')) {
      return <img src={CSVIcon} alt="CSVIcon" className="file-icon" />
    } else return <></>
  }

  return (
    <div className="file-item" key={file?.path} onClick={(e) => handleClick && handleClick(e)}>
      { getFileImage(file) }
      <div className="file-name">{file?.path}</div>
      {/* <div className="file-size">{sizeConversion(file?.size)}</div> */}
      <div className="file-delete" onClick={(e) => removeFile && removeFile(e, file)}>
        <img src={DeleteIcon} alt="DeleteIcon" className="file-delete" />
      </div>
    </div>
  )
}

export default FileItem